import { OnInit, OnDestroy, Optional, Inject } from '@angular/core';
import { Component } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-portfolio-news',
    templateUrl: './dojo-portfolio-news.component.html'
})
export class DojoPortfolioNewsComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    appSettings: any;
    constructor(private contextService: IContextService,
                private translationService: PershingTranslationService,
                private nxiRestService: NxiRestService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        this.appSettings = appSettings;
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            // this.domain = domainContext.domain ? domainContext.domain : CoreConstants.ACCOUNT;
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.getPortfolioNewsParams();
        });
    }

    renderDojoWidget(portfolioNewsParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderPortfolioNews(portfolioNewsParams);
        }
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            dojoApp.destroyWidget('portfolioNews');
        }
    }

    goToNews(): void {
        // TODO: Need to navigate to News page.
        console.log('Navigating to News page');
    }

    getPortfolioNewsParams() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'portfolionewsparams').subscribe(
                resp => {
                    console.log('Retrived common REST TRading widgets param : ', resp.response);
                    if (resp.response) {
                        resp.response.restUrl = this.nxiRestService.serviceUrl + resp.response.restUrl;
                        resp.response.modApiUrl = this.appSettings.ibdConfigMap.modApiUrl;
                        this.renderDojoWidget(resp.response);
                    }
                }
            );
        }
    }
}
